export default __webpack_public_path__ + "static/media/seasonal_non_fluid.7e9c30f6.png";